import styles from './style.postcss';

import React, { PureComponent } from 'react';
import { Button, testClass } from 'omni-common-ui';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import is from 'is_js';

class BottomButtons extends PureComponent {
  _renderButtons() {
    if (is.array(this.props.buttons)) {
      return this.props.buttons.map((button) =>
        <Button className={classnames(styles.BottomButtons_button, testClass(button.text))}
            type={button.primary && Button.Type.primary}
            onClick={() => button.onClick && button.onClick()}
            disabled={button.disabled}
            key={button.text}>
          {button.text}
        </Button>);
    }
    return [
      <Button className={classnames(styles.BottomButtons_button, testClass(`button-${this.props.primaryText}`))}
          type={Button.Type.primary}
          onClick={() => this.props.onPrimaryClick && this.props.onPrimaryClick()}
          disabled={this.props.isPrimaryDisabled}
          key={this.props.primaryText}>
        {this.props.primaryText}
      </Button>,
      <Button className={classnames(styles.BottomButtons_button, testClass(`button-${this.props.secondaryText}`))}
          type={Button.Type.default}
          onClick={() => this.props.onSecondaryClick && this.props.onSecondaryClick()}
          disabled={this.props.isSecondaryDisabled}
          key={this.props.secondaryText}>
        {this.props.secondaryText}
      </Button>,
    ];
  }

  render() {
    return <Button.Container className={classnames(styles.BottomButtons, this.props.className)}
        align="right">
      {this._renderButtons()}
    </Button.Container>;
  }
}

BottomButtons.propTypes = {
  buttons: PropTypes.array,
  primaryText: PropTypes.string,
  secondaryText: PropTypes.string,
  onPrimaryClick: PropTypes.func,
  onSecondaryClick: PropTypes.func,
  isPrimaryDisabled: PropTypes.bool,
  isSecondaryDisabled: PropTypes.bool,
  className: PropTypes.string,
};

export default BottomButtons;



// WEBPACK FOOTER //
// ./containers/Group/IndividualDevelopmentPlan/IndividualDevelopmentPlanDetailView/BottomButtons/index.jsx